"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatementPosition = void 0;
const types_1 = require("../types");
// Given current cursor position in the SQL editor, returns the statement position.
function getStatementPosition(currentToken, statementPositionResolversRegistry) {
    var _a;
    const previousNonWhiteSpace = currentToken === null || currentToken === void 0 ? void 0 : currentToken.getPreviousNonWhiteSpaceToken();
    const previousKeyword = currentToken === null || currentToken === void 0 ? void 0 : currentToken.getPreviousKeyword();
    const previousIsSlash = (_a = currentToken === null || currentToken === void 0 ? void 0 : currentToken.getPreviousNonWhiteSpaceToken()) === null || _a === void 0 ? void 0 : _a.is(types_1.TokenType.Operator, '/');
    const resolvers = statementPositionResolversRegistry.list();
    const positions = [];
    for (const resolver of resolvers) {
        if (resolver.resolve(currentToken, previousKeyword !== null && previousKeyword !== void 0 ? previousKeyword : null, previousNonWhiteSpace !== null && previousNonWhiteSpace !== void 0 ? previousNonWhiteSpace : null, Boolean(previousIsSlash))) {
            positions.push(resolver.id);
        }
    }
    if (positions.length === 0) {
        return [types_1.StatementPosition.Unknown];
    }
    return positions;
}
exports.getStatementPosition = getStatementPosition;
//# sourceMappingURL=getStatementPosition.js.map